
    <div [hidden]="base === 'index-2' || base === 'index-3' || base === 'index-4' || base === 'index-5' || base === 'index-6' || page==='index-rtl'" class="header-topbar text-center">
        <div class="container">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
<p class="d-flex align-items-center fw-medium fs-14 mb-2">
  <i class="fa-brands fa-whatsapp me-2 text-success"></i>
  <a href="https://wa.me/310623010197" target="_blank" class="text-decoration-none text-white">
    WhatsApp : +31 0623010197
  </a>
</p>
                <div class="d-flex align-items-center">
                    <p class="mb-2 me-3 d-flex align-items-center fw-medium fs-14"><i class="isax isax-message-text-15 me-2"></i>Email : info&#64;bookatravel.com</p>
                    <div class="dropdown mb-2 me-3">
                      <a href="javascript:void(0);" class="dropdown-toggle fw-medium fs-14 px-3 py-2 text-white d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                        {{ selectedCountryLabel }}
                      </a>
                      <ul class="dropdown-menu p-2 mt-2">
                        <li *ngFor="let info of supportedInfo">
                          <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);" [class.active]="info.id === selectedCountryId" (click)="onCountryChangeDropdown(info.id)">
                            <i class="fas fa-language me-2"></i>
                            {{ info.currency }}
                            <small class="ms-auto text-muted">{{ getHotelLanguageName(info.hotelLanguage) || info.hotelLanguage }}</small>
                          </a>
                        </li>
                      </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>

